module.exports = __webpack_public_path__ + "sunsemweb/img/yz2.909e3af8.png";